//#region Imports
/**
To use React and state related functionality
*/
import React, { useState } from 'react';
/**
Allows component  to connect the Redux store.
*/
import { connect } from 'react-redux';
/**
To show all Trips
*/
import DirectionsList from './DirectionsList';
/**
To loader while loading trips
*/
import withLoading from '../shared/withLoading';
/**
To show alert icon
*/
import { IconAlert } from '../Icons';
/**
To show Trip warnings
*/
import TripWarnings from './TripWarnings';
//#endregion
const Directions = props => {
    /**
    trips - list of trips
    error - saves any error
    currentTrip - saves current selected trip
    flexUseReservationServices - include requiring reservations filter or not.  "Include trips requiring reservations" Checkbox value. 
    */
    const {trips, error, currentTrip, flexUseReservationServices} = props;
    //It is used to show/hide eligibility text
    const [isChecked, setIsChecked] = useState(!flexUseReservationServices);

    /**
    * Set trip reservation message.
    * Function is used in ShowReservationCheckBox function html from the same component.
    */
    const getCheckmarkValue = () => {
        setIsChecked(!isChecked);
        //Bug_issue-83 Changes -- Vishal Chauhan  Start 
        //Link: https://github.com/Trillium-Solutions/open-trip-planner-ui/issues/83    
        var value = !isChecked;
        if (value) {    
            //If "Include trips requiring reservations" is not checked
            document.getElementById("eligibilityText").textContent="Excluding trips with reservation requirements"
        } else {
            //If "Include trips requiring reservations" is checked
            document.getElementById("eligibilityText").textContent="Including trips with reservation requirements"          
        }
        //Bug_issue-83 Changes -- Vishal Chauhan  End 
    };
    //filter trips that requires reservation
    const legRequiresReservation = trips.filter(trip => {
        return trip.legs.find(leg => leg.requiresReservation);
    });

    const ShowReservationCheckBox = () => {
        if (window.otpConfig.flex2 ){
            //check if there is any trip that requires reservation
            if(legRequiresReservation.length > 0){
                return (
                    <div className="otp-form-control">
                        <input
                            type="checkbox"
                            name="showReservationRequired"
                            id="showReservationRequired"
                            checked={isChecked}
                            onChange={getCheckmarkValue}
                        />
                        <label htmlFor="flexUseReservationServices">Remove trips requiring reservations</label>
                    </div>
                );} else {
                return '';
            } 
        }
    };
    //it trips does not have any error but also there is no trips to show.
    if (!error && trips.length === 0) {
        return (
            <div className="otp-directions">
                <h2>No trips are available.</h2>
            </div>
        );
    }
    //Show error message if trips has an error 
    if (error) {
        return(
            <div className="otp-directions otp-has-error">
                <h2>We were unable to plan your trip.</h2>
                <div className="otp-error">
                    <IconAlert /> {error.msg}
                </div>
            </div>
        );
    }

    return(
        <div className="otp-directions">
            <h2>Here are the best trips for you:</h2>
            <TripWarnings trips={trips} />

            {(window.otpConfig.flex2) &&
                <ShowReservationCheckBox/>
            }
            
            <div className="otp-directions-list">
                <DirectionsList
                    trips={trips}
                    currentTrip={currentTrip} 
                    isChecked={isChecked}
                />      
            </div>
        </div>
    );
};

//Controls get updated when change any direction or change value of use reservation service checkbox  
const mapStateToProps = state => {
    return {
        //Controls comes from directionsReducer
        ...state.directions,
        //save if user reservation service require
        flexUseReservationServices: !(state.form.fields.flexUseReservationServices.value == "false")
    };
};





//show loader while loading trips
const WrappedDirections = withLoading({text:'Loading Directions...'})(Directions);
export default connect(mapStateToProps)(WrappedDirections);